// Generated from .\Source\worker\app-workers\shared\models\grammar-with-annotation\DataflowParser.g4 by ANTLR 4.8
// jshint ignore: start
var antlr4 = require('antlr4/index');

// This class defines a complete generic visitor for a parse tree produced by DataflowParser.

function DataflowParserVisitor() {
	antlr4.tree.ParseTreeVisitor.call(this);
	return this;
}

DataflowParserVisitor.prototype = Object.create(antlr4.tree.ParseTreeVisitor.prototype);
DataflowParserVisitor.prototype.constructor = DataflowParserVisitor;

// Visit a parse tree produced by DataflowParser#IntegerLiteral.
DataflowParserVisitor.prototype.visitIntegerLiteral = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#FloatLiteral.
DataflowParserVisitor.prototype.visitFloatLiteral = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#StringLiteral.
DataflowParserVisitor.prototype.visitStringLiteral = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#RegexLiteral.
DataflowParserVisitor.prototype.visitRegexLiteral = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#integer_literal.
DataflowParserVisitor.prototype.visitInteger_literal = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#index_literal.
DataflowParserVisitor.prototype.visitIndex_literal = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#format_literal.
DataflowParserVisitor.prototype.visitFormat_literal = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#extension_literal.
DataflowParserVisitor.prototype.visitExtension_literal = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#float_literal.
DataflowParserVisitor.prototype.visitFloat_literal = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#typeNames.
DataflowParserVisitor.prototype.visitTypeNames = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#keyword.
DataflowParserVisitor.prototype.visitKeyword = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#basicName.
DataflowParserVisitor.prototype.visitBasicName = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#anyName.
DataflowParserVisitor.prototype.visitAnyName = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#memberIdentifier.
DataflowParserVisitor.prototype.visitMemberIdentifier = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#columnIdentifier.
DataflowParserVisitor.prototype.visitColumnIdentifier = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#variableReference.
DataflowParserVisitor.prototype.visitVariableReference = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#metaVariableReference.
DataflowParserVisitor.prototype.visitMetaVariableReference = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#metaPosReference.
DataflowParserVisitor.prototype.visitMetaPosReference = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#metaMatchReference.
DataflowParserVisitor.prototype.visitMetaMatchReference = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#metaArgumentReference.
DataflowParserVisitor.prototype.visitMetaArgumentReference = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#parameter.
DataflowParserVisitor.prototype.visitParameter = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#variable.
DataflowParserVisitor.prototype.visitVariable = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#sectionName.
DataflowParserVisitor.prototype.visitSectionName = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#basicFunction.
DataflowParserVisitor.prototype.visitBasicFunction = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#metafunction.
DataflowParserVisitor.prototype.visitMetafunction = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#BasicSelector.
DataflowParserVisitor.prototype.visitBasicSelector = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#AnySelector.
DataflowParserVisitor.prototype.visitAnySelector = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#columnOperand.
DataflowParserVisitor.prototype.visitColumnOperand = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#transformFunction.
DataflowParserVisitor.prototype.visitTransformFunction = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#transientOperand.
DataflowParserVisitor.prototype.visitTransientOperand = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#parameterOperand.
DataflowParserVisitor.prototype.visitParameterOperand = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#InterpolateText.
DataflowParserVisitor.prototype.visitInterpolateText = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#InterpolateExpr.
DataflowParserVisitor.prototype.visitInterpolateExpr = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#Cast.
DataflowParserVisitor.prototype.visitCast = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#AddMinus.
DataflowParserVisitor.prototype.visitAddMinus = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#VariableRef.
DataflowParserVisitor.prototype.visitVariableRef = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#Or.
DataflowParserVisitor.prototype.visitOr = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#ColumnOperandRef.
DataflowParserVisitor.prototype.visitColumnOperandRef = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#Struct.
DataflowParserVisitor.prototype.visitStruct = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#MetaVariableRef.
DataflowParserVisitor.prototype.visitMetaVariableRef = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#MulDivMod.
DataflowParserVisitor.prototype.visitMulDivMod = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#EqNotEq.
DataflowParserVisitor.prototype.visitEqNotEq = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#MetaPosRef.
DataflowParserVisitor.prototype.visitMetaPosRef = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#TransformFunctionExpr.
DataflowParserVisitor.prototype.visitTransformFunctionExpr = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#Comparison.
DataflowParserVisitor.prototype.visitComparison = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#ArrayIndexer.
DataflowParserVisitor.prototype.visitArrayIndexer = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#TransientRef.
DataflowParserVisitor.prototype.visitTransientRef = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#LiteralExpr.
DataflowParserVisitor.prototype.visitLiteralExpr = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#FieldSelector.
DataflowParserVisitor.prototype.visitFieldSelector = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#FunctionExpr.
DataflowParserVisitor.prototype.visitFunctionExpr = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#EmptyArray.
DataflowParserVisitor.prototype.visitEmptyArray = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#UnaryMinus.
DataflowParserVisitor.prototype.visitUnaryMinus = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#CommentedExpression.
DataflowParserVisitor.prototype.visitCommentedExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#Array.
DataflowParserVisitor.prototype.visitArray = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#MetaFunctionExpr.
DataflowParserVisitor.prototype.visitMetaFunctionExpr = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#Interpolation.
DataflowParserVisitor.prototype.visitInterpolation = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#Not.
DataflowParserVisitor.prototype.visitNot = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#ParameterRef.
DataflowParserVisitor.prototype.visitParameterRef = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#Scope.
DataflowParserVisitor.prototype.visitScope = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#And.
DataflowParserVisitor.prototype.visitAnd = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#MetaMatchRef.
DataflowParserVisitor.prototype.visitMetaMatchRef = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#Xor.
DataflowParserVisitor.prototype.visitXor = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#MetaArgumentRef.
DataflowParserVisitor.prototype.visitMetaArgumentRef = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#Map.
DataflowParserVisitor.prototype.visitMap = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#assignment.
DataflowParserVisitor.prototype.visitAssignment = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#transientAssignment.
DataflowParserVisitor.prototype.visitTransientAssignment = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#metaAssignment.
DataflowParserVisitor.prototype.visitMetaAssignment = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#sections.
DataflowParserVisitor.prototype.visitSections = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#section.
DataflowParserVisitor.prototype.visitSection = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#key.
DataflowParserVisitor.prototype.visitKey = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#keyExpression.
DataflowParserVisitor.prototype.visitKeyExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#configName.
DataflowParserVisitor.prototype.visitConfigName = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#configuration.
DataflowParserVisitor.prototype.visitConfiguration = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#transformation.
DataflowParserVisitor.prototype.visitTransformation = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#transformName.
DataflowParserVisitor.prototype.visitTransformName = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#transformed.
DataflowParserVisitor.prototype.visitTransformed = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#groupName.
DataflowParserVisitor.prototype.visitGroupName = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#transformedGroup.
DataflowParserVisitor.prototype.visitTransformedGroup = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#inputTransformedList.
DataflowParserVisitor.prototype.visitInputTransformedList = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#inputDefinition.
DataflowParserVisitor.prototype.visitInputDefinition = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#outputDefinition.
DataflowParserVisitor.prototype.visitOutputDefinition = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#outputTransformed.
DataflowParserVisitor.prototype.visitOutputTransformed = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#flowStatement.
DataflowParserVisitor.prototype.visitFlowStatement = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#IntegerType.
DataflowParserVisitor.prototype.visitIntegerType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#ShortType.
DataflowParserVisitor.prototype.visitShortType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#LongType.
DataflowParserVisitor.prototype.visitLongType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#DoubleType.
DataflowParserVisitor.prototype.visitDoubleType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#FloatType.
DataflowParserVisitor.prototype.visitFloatType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#BooleanType.
DataflowParserVisitor.prototype.visitBooleanType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#StringType.
DataflowParserVisitor.prototype.visitStringType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#DateType.
DataflowParserVisitor.prototype.visitDateType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#ByteType.
DataflowParserVisitor.prototype.visitByteType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#BinaryType.
DataflowParserVisitor.prototype.visitBinaryType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#TimestampType.
DataflowParserVisitor.prototype.visitTimestampType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#DecimalType.
DataflowParserVisitor.prototype.visitDecimalType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#IntegralType.
DataflowParserVisitor.prototype.visitIntegralType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#FractionalType.
DataflowParserVisitor.prototype.visitFractionalType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#NumberType.
DataflowParserVisitor.prototype.visitNumberType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#AnyType.
DataflowParserVisitor.prototype.visitAnyType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#complex.
DataflowParserVisitor.prototype.visitComplex = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#ArrayType.
DataflowParserVisitor.prototype.visitArrayType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#SimpleType.
DataflowParserVisitor.prototype.visitSimpleType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#ComplexType.
DataflowParserVisitor.prototype.visitComplexType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#MapType.
DataflowParserVisitor.prototype.visitMapType = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#parameterDefinition.
DataflowParserVisitor.prototype.visitParameterDefinition = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#OneFormat.
DataflowParserVisitor.prototype.visitOneFormat = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#ManyFormats.
DataflowParserVisitor.prototype.visitManyFormats = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#inlineDatatype.
DataflowParserVisitor.prototype.visitInlineDatatype = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#externalDatatype.
DataflowParserVisitor.prototype.visitExternalDatatype = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#columnDefinition.
DataflowParserVisitor.prototype.visitColumnDefinition = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#parameters.
DataflowParserVisitor.prototype.visitParameters = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#functionDefinition.
DataflowParserVisitor.prototype.visitFunctionDefinition = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#functions.
DataflowParserVisitor.prototype.visitFunctions = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by DataflowParser#dataflow.
DataflowParserVisitor.prototype.visitDataflow = function(ctx) {
  return this.visitChildren(ctx);
};



exports.DataflowParserVisitor = DataflowParserVisitor;